module.exports = __webpack_public_path__ + "static/downtown-172ec2db84b6d213b2b958be5312c55e.svg";